module.exports = __webpack_public_path__ + "img/DualRing-1.1s-200px.2a6a5f2c.svg";